import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { ActiveErrorData, ActiveErrorsStore } from '@store';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-active-errors-list',
  templateUrl: './active-errors-list.component.html',
  styleUrls: ['./active-errors-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveErrorsListComponent implements OnInit {
  activeErrorList$: Observable<ActiveErrorData[]>;
  deviceSerial: string;
  gatewaySerial: string;

  constructor(
    public activeErrorsStore: ActiveErrorsStore,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.gatewaySerial = queryParams.get('gatewaySerial');
      this.deviceSerial = queryParams.get('deviceSerial');
      this.activeErrorList$ = this.activeErrorsStore.getActiveGatewayErrors(
        this.gatewaySerial,
        this.deviceSerial,
        true,
        true
      );

      this.activeErrorsStore
        .isAnyErrorSelectedForDeviceBySerial(this.deviceSerial)
        .pipe(take(1))
        .subscribe((isAnySelected) => {
          if (!isAnySelected) {
            this.activeErrorsStore.selectFirstActiveErrorForThisDevice(
              this.gatewaySerial,
              this.deviceSerial
            );
          }
        });
      this.cdr.markForCheck();
    });
  }
}
